import { all, fork } from 'redux-saga/effects'

import { exercisessWatcherSaga } from 'features/exercises/store/exercises.sagas'
import { postsWatcherSaga } from 'features/posts/store/posts.sagas'
import { videosWatcherSaga } from 'features/videos/store/videos.sagas'

export function* rootSaga() {
  yield all([fork(postsWatcherSaga)])
  yield all([fork(videosWatcherSaga)])
  yield all([fork(exercisessWatcherSaga)])
}

export default rootSaga
